(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ui/dialog/assets/javascripts/.trinidad/api.trinidad.js') >= 0) return;  svs.modules.push('/components/ui/dialog/assets/javascripts/.trinidad/api.trinidad.js'); "use strict";

(() => {

  "use strict";


  var __webpack_require__ = {};





  (() => {

    __webpack_require__.n = module => {
      var getter = module && module.__esModule ?
      () => module['default'] :
      () => module;

      __webpack_require__.d(getter, {
        a: getter
      });


      return getter;
    };

  })();





  (() => {

    __webpack_require__.d = (exports, definition) => {
      for (var key in definition) {
        if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
          Object.defineProperty(exports, key, {
            enumerable: true,
            get: definition[key]
          });
        }

      }

    };

  })();





  (() => {
    __webpack_require__.o = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);

  })();



  var __webpack_exports__ = {}; 

  __webpack_require__.d(__webpack_exports__, {
    "default": () =>
    api
  });

  ; 

  const external_gsap_namespaceObject = window["gsap"];

  var external_gsap_default = __webpack_require__.n(external_gsap_namespaceObject);

  ; 


  class PubSub {
    constructor() {
      this.callbacks = {};
    }

    emit(event, data) {
      if (this.callbacks[event]) {
        this.callbacks[event].forEach(callback => {
          callback.callback.call(callback.context || this, data);
        });
      }
    }

    on(event, context, callback) {
      if (typeof context === 'function') {
        callback = context;
        context = undefined;
      }

      if (!this.callbacks[event]) {
        this.callbacks[event] = [];
      }

      this.callbacks[event].push({
        context,
        callback
      });
    }

    off(event, context) {
      context = context || this;

      if (this.callbacks[event]) {
        for (let i = 0; i < this.callbacks[event].length; i++) {
          const item = this.callbacks[event][i];

          if (item.context === context) {
            this.callbacks[event].splice(i, 1);
            break;
          }
        }
      }
    }

  }


  const pubsub = PubSub;
  ; 


  const CONTEXTUAL = 'contextual';
  const POPUP = 'popup';
  const TOASTER = 'toaster';

  const constants_area = {
    CONTEXTUAL,
    POPUP,
    TOASTER
  };
  ; 


  class Accessibility {
    constructor(options) {
      this.log = window.svs ? new window.svs.core.log.Logger('DialogAccessibility') : console;
      this.el = options.el;
      this.type = options.type;
      this.attachTo = options.attachTo;
      this.activeElBeforeOpen = options.activeElBeforeOpen ? options.activeElBeforeOpen : document.body;

      if (this.type === POPUP) {
        this.initPopup();
      }

      if (this.type === TOASTER) {
        this.initToaster();
      }
    }

    initPopup() {
      this.focusCatcher = document.createElement('div');
      this.focusCatcher.setAttribute('tabindex', '0');
      this.attachTo.appendChild(this.focusCatcher);
      this.focusCatcher.addEventListener('focus', () => {
        this.log.debug('User tries to tab out of dialog - Let us move them back to the top.');
        this.el.focus();
      });

      this.keyEventsListenerPopupRef = event => {
        this.keyEventsListenerPopup(event);
      };

      document.addEventListener('keydown', this.keyEventsListenerPopupRef);
    } 


    keyEventsListenerPopup(e) {
      if (e.shiftKey && e.code === 'Tab' && this.el === document.activeElement) {
        this.log.debug('User tries to tab backwards out of dialog - let us move them to the last button in dialog.');
        e.preventDefault();
        const buttons = this.el.querySelectorAll('.js-dialog-item')[0].querySelectorAll('.dialog-button');
        const buttonsLength = buttons.length; 

        if (buttons[buttonsLength - 1].getAttribute('tabindex') === '-1') {
          buttons[buttonsLength - 2].focus();
        } else {
          buttons[buttonsLength - 1].focus();
        }
      } 


      if (e.keyCode && e.keyCode === 27 || e.key && e.key.toLowerCase() === 'esc' || e.key && e.key.toLowerCase() === 'escape') {
        this.triggerClick(document.querySelector('.dialog-button-secondary'));
      }
    }

    initToaster() {
      this.keyEventsListenerToasterRef = event => {
        this.keyEventsListenerToaster(event);
      };

      document.addEventListener('keydown', this.keyEventsListenerToasterRef);
    } 


    keyEventsListenerToaster(e) {
      if (e.shiftKey && e.key && e.key.toLowerCase() === 'tab' && this.el === document.activeElement) {
        e.preventDefault();
        this.activeElBeforeOpen.focus();
      } 


      if (!e.shiftKey && e.key && e.key.toLowerCase() === 'tab' && this.el.querySelectorAll('.dialog-button')[this.el.querySelectorAll('.dialog-button').length - 1] === document.activeElement) {
        e.preventDefault();
        this.log.debug('You reached the end of the line.');
        this.activeElBeforeOpen.focus();
      }

      if (e.key && e.key.toLowerCase() === 'esc' && (this.el === document.activeElement || this.el.contains(document.activeElement))) {
        e.preventDefault();
        this.log.debug('Escaping to the element ');
        this.activeElBeforeOpen.focus();
      }
    }

    focusElement(el) {
      el.focus();
    }

    removeListeners() {
      this.log.debug('Remove Keyboard Events from ', this.type);

      if (this.type === POPUP) {
        document.removeEventListener('keydown', this.keyEventsListenerPopupRef);
      } else if (this.type === TOASTER) {
        document.removeEventListener('keydown', this.keyEventsListenerToasterRef);
      }
    } 


    triggerClick(element) {
      element.dispatchEvent(new Event('mousedown'));
      element.dispatchEvent(new Event('mouseup'));
    }

  }


  const accessibility = Accessibility;
  ; 


  class DialogPopupsArea extends pubsub {
    constructor(options) {
      super();
      this.log = window.svs ? new window.svs.core.log.Logger('DialogPopupsArea') : console;
      this.name = POPUP;
      this.items = [];
      this.el = options.el;
      this.options = options;
      this.at = 0;
      this.hasRendered = false;
      this.isOpen = false;
      this.offsetHeight = 50;
      this.init();
    }

    init() {
      this.el = document.createElement('div');
      this.el.className += 'js-dialog-items dialog-items js-dialog-popup-items dialog-popup-items focus-inverted';
      this.el.setAttribute('role', 'dialog');
      this.el.setAttribute('tabindex', '0');
      this.options.attachTo.appendChild(this.el); 

      const accessibilityOptions = {
        el: this.el,
        type: POPUP,
        activeElBeforeOpen: document.activeElement,
        attachTo: this.options.attachTo
      };
      this.accessibility = new accessibility(accessibilityOptions);
      window.addEventListener('resize', () => {
        this.resize();
      });
      window.addEventListener('orientationchange', () => {
        setTimeout(() => {
          this.resize();
        }, 400);
      });

      if (window.ResizeObserver !== undefined) {
        this.resizeObserver = new ResizeObserver(() => {
          this.resize();
        });
      }
    }

    resize() {
      const currentItem = this.items[0];

      if (currentItem) {
        const windowH = this.getWindowAvialiableHeight();
        currentItem.setScrollableHeight('auto');

        if (windowH > currentItem.el.offsetHeight) {
          currentItem.setScrollableHeight('auto'); 

          external_gsap_default().set(this.el, {
            height: currentItem.el.clientHeight
          });
        } else {
          currentItem.setScrollableHeight(windowH); 

          external_gsap_default().set(this.el, {
            height: windowH
          });
        }
      }
    }

    add(dialog) {
      if (dialog) {
        let itemsToAdd = []; 

        const toasters = this.options.areas[TOASTER]; 

        if (toasters && toasters.count()) {
          this.log.debug('Converted all toasters to popups');
          itemsToAdd = toasters.convertToPopups() || [];
        } 


        itemsToAdd.push(dialog);
        itemsToAdd.forEach(dialog => {
          dialog.el.className += ' dialog-popup-item';
          this.append(dialog);
        }); 

        if (!this.isOpen) {
          this.open();
        }
      }
    }

    getWindowAvialiableHeight() {
      return window.innerWidth > 620 ? window.innerHeight - 48 : window.innerHeight - 24;
    }

    getNeededHeight() {
      if (this.getWindowAvialiableHeight() > this.items[0].height) {
        return this.items[0].height;
      }

      return this.getWindowAvialiableHeight();
    }

    getHeight() {
      if (window.innerHeight < this.items[0].height) {
        return window.innerHeight;
      }

      return this.items[0].height;
    }

    open() {
      this.isOpen = true;
      this.log.debug('First dialog to be opened');
      this.el.classList.remove('dialog-items-closed');
      this.emit('open', {
        area: this.area
      });
      this.emit('changed', this.items[0]);
      this.resize();
      const tl = external_gsap_default().timeline();
      tl.fromTo(this.el, {
        opacity: 0,
        scale: 0.8,
        height: this.getNeededHeight()
      }, {
        duration: 0.15,
        opacity: 1,
        scale: 1,
        ease: 'power1.out',
        height: this.getNeededHeight(),
        onComplete: () => {
          this.items[0].reveal();
        }
      });
      tl.fromTo(this.el, {
        boxShadow: '0'
      }, {
        duration: 0.2,
        boxShadow: '0 0 48px 4px rgba(0, 0, 0, .5)'
      });
    }

    next() {
      this.emit('changed', this.items[0]);
      this.log.debug('Next dialog to be opened');
      external_gsap_default().to(this.el, {
        duration: 0.15,
        height: this.getHeight(),
        onComplete: () => {
          this.resize();
          this.items[0].next();
        }
      });
    }

    closeFromOutside(e) {
      const item = this.items[0]; 

      if (item) {
        const actions = item.options.actions;

        if (actions.length === 1 && typeof actions[0].callback === 'function' && e) {
          actions[0].callback(e, item.el.getElementsByClassName('js-dialog-item-checkbox'), item);
        } else {
          this.items[0].close();
        }
      }
    }

    close() {
      this.log.debug('No more dialogs here, close container');
      this.accessibility.removeListeners();

      if (this.resizeObserver !== undefined) {
        this.resizeObserver.disconnect();
      }

      external_gsap_default().to(this.el, {
        duration: 0.2,
        boxShadow: 0,
        opacity: 0,
        scale: 0.9,
        delay: 0.1,
        onComplete: () => {
          this.el.classList.add('dialog-items-closed');
          this.isOpen = false;
          this.accessibility.activeElBeforeOpen.focus();
          this.emit('close', {
            area: this.area
          });
          this.log.debug('Container closed!'); 

          if (this.items.length) {
            this.open();
          }
        }
      });
    }

    append(dialog) {
      this.log.debug('Append dialog to be opened');
      dialog._queue = this;
      dialog.area = this.name;
      dialog.on('closed', this, () => {
        this.log.debug('A dialog was closed, now handle it.');
        this.unload(dialog);
      });
      dialog.on('revealed', this, () => {
        this.log.debug('A dialog was revealed.'); 

        setTimeout(() => {
          this.accessibility.focusElement(this.el);
        }, 1);
      });

      if (this.items.length && this.items[0].requireHandshake) {
        this.items.splice(1, 0, dialog);

        if (this.el.children.length > 1) {
          this.el.insertBefore(dialog.el, this.el.children[1]);
        } else {
          this.el.appendChild(dialog.el);
        }
      } else {
        this.items.push(dialog);
        this.el.appendChild(dialog.el);
      }

      if (this.resizeObserver !== undefined) {
        this.resizeObserver.observe(dialog._content._icon.el);
      }

      dialog.setDimensions();
      dialog.setupAnimations();
    }

    unload(dialog) {
      this.items.forEach((item, i) => {
        if (item._id === dialog._id) {
          if (this.resizeObserver !== undefined) {
            this.resizeObserver.unobserve(item._content._icon.el);
          }

          this.items.splice(i, 1);
          this.el.removeChild(item.el);
        }
      });

      if (!this.items.length) {
        this.close();
      } else {
        this.next();
        this.status();
      }
    }

    status() {
      this.log.debug("".concat(this.name, " queue, ").concat(this.items.length, " still remain"));
    }

    count() {
      return this.items.length;
    }

  }


  const popup_area = DialogPopupsArea;
  ; 


  class DialogToasterArea extends pubsub {
    constructor(options) {
      super();
      this.log = window.svs ? new window.svs.core.log.Logger('DialogToasterArea') : console;
      this.name = TOASTER;
      this.items = [];
      this.el = options.el;
      this.options = options;
      this.render();
      this.init();
    }

    init() {
      const accessibilityOptions = {
        el: this.el,
        type: TOASTER,
        activeElBeforeOpen: document.activeElement
      };
      this.accessibility = new accessibility(accessibilityOptions);
      window.addEventListener('resize', () => {
        const currentItem = this.items[0];

        if (currentItem) {
          this.setPositions();
        }
      });

      if (window.ResizeObserver !== undefined) {
        this.resizeObserver = new ResizeObserver(() => {
          this.updatePositions();
        });
      }
    }

    render() {
      this.el = document.createElement('div');
      this.el.className += 'js-dialog-items dialog-items dialog-toaster-items js-dialog-toaster-items focus-inverted';
      this.el.setAttribute('tabindex', '0');
      this.options.attachTo.appendChild(this.el);
    }

    remove() {
      this.options && this.options.attachTo && this.options.attachTo.removeChild(this.el);
      this.el = null;
      this.accessibility.removeListeners();
      this.emit('close');
    }

    add(dialog) {
      const popups = this.options.areas[POPUP];

      if (!this.el) {
        this.render();
      }

      if (!popups || !popups.count() || popups && popups.count() === 1 && popups.items[0]._isClosing) {
        this.log.debug('Added to toasters');
        this.append(dialog);
        dialog.reveal();
        this.updatePositions();
        this.accessibility.focusElement(this.el);
      } else {
        this.log.debug('Added to popups');
        dialog.allowDimmerClick = false;
        popups.add(dialog);
      }
    }

    close(timing) {
      this.log.debug('No more dialogs here, close container', timing !== undefined ? timing : 0.2);
      const tweenVars = {
        height: 0,
        onComplete: () => {
          setTimeout(() => {
            this.remove();
          }, 100);
        }
      };

      if (timing === 0) {
        this.log.debug('Set height 0');
        external_gsap_default().set(this.el, tweenVars);
      } else {
        this.log.debug('Animate height 0');
        external_gsap_default().to(this.el, 0.2, tweenVars);
      }
    }

    append(dialog) {
      this.log.debug('Append dialog to be opened');
      dialog._queue = this;
      dialog.el.className += ' dialog-toaster-item';
      dialog.on('closed', this, () => {
        this.log.debug('A dialog was closed, now handle it.');
        this.unload(dialog);
      });
      this.items.push(dialog);
      this.el.appendChild(dialog.el);

      if (this.resizeObserver !== undefined) {
        this.resizeObserver.observe(dialog.el);
      }
    }

    setPositions() {
      this.log.debug('Set positions on toaster items');
      let totalHeight = 0;
      this.items.forEach(item => {
        external_gsap_default().set(item.el, {
          top: totalHeight
        });
        totalHeight += item.el.offsetHeight;
      });
      external_gsap_default().set(this.el, {
        height: totalHeight
      });
    }

    updatePositions() {
      this.log.debug('Update toaster items heights');
      let totalHeight = 0;
      this.items.forEach(item => {
        external_gsap_default().to(item.el, {
          duration: 0.2,
          top: totalHeight
        });
        totalHeight += item.el.offsetHeight;
      });
      external_gsap_default().to(this.el, {
        duration: 0.2,
        height: totalHeight
      });
    }

    unload(dialog) {
      this.items.forEach((item, i) => {
        if (item._id === dialog._id) {
          if (this.resizeObserver !== undefined) {
            this.resizeObserver.unobserve(item.el);
          }

          this.items.splice(i, 1);
          external_gsap_default().to(item.el, {
            duration: 0.2,
            height: 0,
            onComplete: () => {
              this.el && this.el.removeChild(item.el);
            }
          });
          item._rendered = false;
        }
      });

      if (!this.items.length) {
        this.log.debug('Set focus to element that was active before toaster was opened', this.accessibility.activeElBeforeOpen);
        this.accessibility.activeElBeforeOpen.focus();
        this.accessibility.removeListeners();

        if (this.resizeObserver !== undefined) {
          this.resizeObserver.disconnect();
        }

        this.close();
      } else {
        this.updatePositions();
      }
    }

    convertToPopups() {
      this.log.debug("Convert ".concat(this.items.length, " toasters -> popups"));
      const convertedItems = [];
      this.items.forEach(item => {
        if (item.options.convertToPopup) {
          this.el.removeChild(item.el);
          item.off('closed', this);
          item.options.autoClose = false;
          item.el.removeAttribute('style');
          item.options.area = POPUP;
          item.el.classList.remove('dialog-toaster-item');
          convertedItems.push(item);
        } else {
          this.log.debug("Toaster with title ".concat(item.options.title || '[not set]', " not converted to popup"));
        }
      });
      this.items = [];
      this.close(0);
      return !convertedItems.length ? false : convertedItems;
    }

    status() {
      this.log.debug("".concat(this.name, " queue, ").concat(this.items.length, " still remain"));
    }

    count() {
      let c = 0;
      this.items.forEach(item => {
        if (!item.options.skipPopupQueue) {
          c++;
        }
      });
      return c;
    }

  }


  const toaster_area = DialogToasterArea;
  ; 



  const areas = {
    [POPUP]: popup_area,
    [TOASTER]: toaster_area
  };
  ; 


  class DialogQueue extends pubsub {
    constructor(options) {
      super();
      this.log = window.svs ? new window.svs.core.log.Logger('DialogQueue') : console;
      this.options = options;
      this.areas = {};
      this.at = 0;
    }

    addEventListeners(area) {
      area.on('open', this, () => {
        this.emit('showDimmer');
      });
      area.on('close', this, () => {
        const popupCount = this.areas && this.areas[POPUP] && this.areas[POPUP].count();
        const toasterCount = this.areas && this.areas[TOASTER] && this.areas[TOASTER].count();
        const contextualCount = this.areas && this.areas[CONTEXTUAL] && this.areas[CONTEXTUAL].count();

        if (this.count() === 0) {
          this.log.debug('Nothing more to show, remove all');
          this.emit('hideDimmer');
        } else if (popupCount === 0 && (toasterCount > 0 || contextualCount > 0)) {
          this.emit('hideDimmer');
        }
      });
      area.on('changed', this, options => {
        this.emit('changed', options);
      });
    }

    close() {
      for (const areaKey in this.areas) {
        if (Object.prototype.hasOwnProperty.call(this.areas, areaKey)) {
          const area = this.areas[areaKey];
          area.close();
        }
      }
    }

    closeFromOutside(e) {
      for (const areaKey in this.areas) {
        if (Object.prototype.hasOwnProperty.call(this.areas, areaKey)) {
          const area = this.areas[areaKey];

          if (area.closeFromOutside) {
            area.closeFromOutside(e);
          }
        }
      }
    }

    add(dialog) {
      const dialogArea = dialog.options.area;

      if (dialogArea === TOASTER && !dialog.options.convertToPopup && Boolean(this.areas.popup && this.areas.popup.items && this.areas.popup.items.length > 0)) {
        this.log.debug("Do not add toaster with title ".concat(dialog.options.title || '[not set]', " to queue because there is already popups in queue and this toaster has convertToPopup set to false"));
      } else {
        if (!this.areas[dialogArea]) {
          if (dialog.area) {
            this.areas[dialogArea] = new dialog.area({
              attachTo: this.options.attachTo,
              areas: this.areas
            });
          } else {
            this.areas[dialogArea] = new areas[dialogArea]({
              attachTo: this.options.attachTo,
              areas: this.areas
            });
          }

          this.addEventListeners(this.areas[dialogArea]);
        }

        this.log.debug('Added a dialog to queue');
        this.areas[dialogArea].add(dialog);
        this.log.debug(this.count());
        this.emit('added', dialog);
      }
    }

    count() {
      let itemsInQueue = 0; 

      for (const areaKey in this.areas) {
        if (Object.prototype.hasOwnProperty.call(this.areas, areaKey)) {
          const area = this.areas[areaKey];
          itemsInQueue += area.items.length;
        }
      }

      return itemsInQueue;
    }

    status() {
      let msg = ''; 

      for (const areaKey in this.areas) {
        if (Object.prototype.hasOwnProperty.call(this.areas, areaKey)) {
          const area = this.areas[areaKey];
          msg = "".concat(area.name, " queue, ").concat(area.items.length, " still remain");
        }
      }

      this.log.debug(msg);
    }

  }


  const dialog_queue = DialogQueue;
  ; 


  class Dialog extends pubsub {
    constructor(options) {
      super();
      this.options = options;
      this.log = window.svs ? new window.svs.core.log.Logger('Dialog') : console;
      this.isBlocking = false;
    }

    createWrapper() {
      this.el = document.createElement('div');
      this.el.className += 'js-dialog dialog';
      this.el.setAttribute('tabindex', '-1');
    }

    createQueue() {
      this.queue = new dialog_queue({
        attachTo: this.el
      });
    }

    render() {
      this.el = document.querySelector('.js-dialog');

      if (this.el) {
        this.log.debug('No more dialog containers needed.');
      } else {
        this.createWrapper(); 

        document.body.appendChild(this.el);
      }

      this.createQueue();
      this.addEventListeners();
    }

    addEventListeners() {
      this.queue.on('changed', this, dialog => {
        this.updateClickEvents(dialog);
      });
      this.queue.on('added', this, dialog => {
        this.updateClickEvents(dialog);
      });
      this.queue.on('showDimmer', this, () => {
        this.showDimmer();

        if (!this.isBlocking) {
          this.isBlocking = true;
          this.emit('blocking', this.isBlocking);
        }
      });
      this.queue.on('hideDimmer', this, () => {
        this.hideDimmer();

        if (this.isBlocking) {
          this.isBlocking = false;
          this.emit('blocking', this.isBlocking);
        }
      });
    }

    showDimmer() {
      if (!this.isDimmed) {
        external_gsap_default().to(this.el, 0.2, {
          backgroundColor: 'rgba(0, 0, 0, .4)',
          onComplete: () => {
            if (this.el) {
              this.el.classList.add('dialog-dimmed');
            }
          }
        });
        this.isDimmed = true;
      }
    }

    hideDimmer() {
      const popupCount = this.queue && this.queue.areas && this.queue.areas[POPUP] && this.queue.areas[POPUP].count();
      const toasterCount = this.queue && this.queue.areas && this.queue.areas[TOASTER] && this.queue.areas[TOASTER].count();
      const contextualCount = this.queue && this.queue.areas && this.queue.areas[CONTEXTUAL] && this.queue.areas[CONTEXTUAL].count();

      if (this.queue && !this.queue.count()) {
        if (this.isDimmed) {
          external_gsap_default().to(this.el, 0.1, {
            backgroundColor: 'rgba(0,0,0,0)',
            onComplete: () => {
              if (!this.queue.count()) {
                this.remove();
              }
            }
          });
        } else {
          this.remove();
        }

        this.isDimmed = false;
      } else if (popupCount === 0 && (toasterCount > 0 || contextualCount > 0)) {
        if (this.isDimmed) {
          external_gsap_default().to(this.el, 0.1, {
            backgroundColor: 'rgba(0,0,0,0)',
            onComplete: () => {
              if (this.el) {
                this.el.classList.remove('dialog-dimmed');
              }
            }
          });
        }

        this.isDimmed = false;
      }
    }

    updateClickEvents(dialog) {
      if (dialog && dialog.allowDimmerClick) {
        this.addClickEvents();
      } else {
        this.removeClickEvents();
      }
    }

    addClickEvents() {
      this.el.classList.add('dialog-close-outside-click');

      this.el.onclick = e => {
        if (e.target === this.el) {
          this.queue.closeFromOutside(e);
          this.removeClickEvents();
        }
      };
    }

    remove() {
      this.removeClickEvents();

      if (this.el) {
        document.body.removeChild(this.el);
        this.el = null;
      }
    }

    removeClickEvents() {
      if (this.el) {
        this.el.classList.remove('dialog-close-outside-click');
        this.el.onclick = null;
      }
    }

    add(dialog) {
      if (!this.el) {
        this.render();
      }

      this.queue.add(dialog);
    }

    close() {
      this.queue && this.queue.closeFromOutside();
    }

  }


  const dialog = Dialog;
  ; 


  window.svs = window.svs || {};
  window.svs.ui = window.svs.ui || {};
  window.svs.ui.dialog = window.svs.ui.dialog || {};

  if (window.svs.ui.dialog.Confirm) {
    window.svs.ui.dialog.DialogConfirm = window.svs.ui.dialog.Confirm;
  }


  const api = new dialog();
  (((window.svs = window.svs || {}).ui = window.svs.ui || {}).dialog = window.svs.ui.dialog || {}).api = __webpack_exports__.default;
})();
 })(window);